import { EVENTS } from "@/lib/constants";
import { Heart } from "lucide-react";

export default function Events() {
  return (
    <section
      id="events"
      data-testid="events-section"
      className="section bg-sage-soft relative overflow-hidden"
    >
      <div className="mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <span className="eyebrow left">gatherings we love</span>
            <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--brown))]">
              Catering for families, churches, weddings, and{" "}
              <span className="font-script text-[hsl(var(--rose-deep))]">
                community
              </span>{" "}
              events.
            </h2>
            <p className="mt-4 text-[hsl(var(--brown-soft))] leading-relaxed">
              Whether it's a sanctuary fellowship or a backyard reunion under
              string lights, we set a table that feels personal. Tell us the
              occasion — we'll bring the food, the warmth, and the platters.
            </p>
            <a
              href="#quote"
              data-testid="events-cta"
              className="btn-pill btn-primary mt-7 text-xs"
            >
              Plan Your Event
            </a>
          </div>

          <div className="lg:col-span-7">
            <ul className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {EVENTS.map((e, i) => (
                <li
                  key={e}
                  data-testid={`event-${e.toLowerCase().replace(/\s+/g, "-")}`}
                  className="recipe-card px-4 py-4 bg-[hsl(var(--cream))] flex items-center gap-2.5"
                  style={{
                    animation: `floatin 0.6s ${i * 0.04}s ease-out both`,
                  }}
                >
                  <Heart
                    size={14}
                    className="shrink-0 text-[hsl(var(--rose-deep))]"
                    fill="currentColor"
                  />
                  <span className="text-sm font-medium text-[hsl(var(--brown))]">
                    {e}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
